import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import { bindActionCreators, Dispatch } from 'redux';
import Component from './Component';
import selectors from './selectors';
import actions from './actions';

const mapStateToProps: any = createSelector(selectors.selectCount, (count) => ({
  count: count ?? 0,
}));

const mapDispatchToProps: any = (dispatch: Dispatch<any>) => bindActionCreators(actions, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Component);
